import { GENDER } from "@/constants.js";
import * as utility from "./utility.js";

export function handleInitialMutation(word) {}

export function handleInitialMutationSingular(word) {
  var w = word.emiWord;
  if (word.gender == GENDER.masculine) {
    if (utility.beginsWithVowel(w)) {
      return "t-" + w;
    } else return w;
  }
  if (word.gender == GENDER.feminine) {
    return handleFeminineSingular(word);
  }
  if (word.gender == GENDER.masculine_feminine) {
    return w;
  } else return w;
}

function handleFeminineSingular(word) {
  var w = word.emiWord;
  var firstLetter = utility.firstLetter(w);
  if (utility.beginsWithVowel(w) || utility.beginsDLNRT(w)) return w;
  if (utility.beginsWithS(w)) {
    var secondletter = utility.nthLetter(w, 1);
    if (
      utility.letterIsVowel(secondletter) ||
      utility.letterIsNRL(secondletter)
    ) {
      return "t" + w;
    } else {
      return w;
    }
  }
  if (utility.beginsBCFGMP(w)) {
    return utility.lenite(w);
  }
}

export function handleInitialMutationPlural(word) {
  if (utility.beginsWithVowel(word)) return utility.lenite(word);
  else return word;
}
